<nav class="navbar navbar-expand-lg bg-primary fixed-top">
    <div class="container-fluid mx-5">
        <a class="navbar-brand" href="/">
            <img src="images/logo-white.png" alt="Abacus Analytics Logo" />
        </a>

        <button class="navbar-toggler bg-white"
                type="button"
                aria-controls="navbarSupportedContent"
                [attr.aria-expanded]="isNavbarExpanded"
                aria-label="Toggle navigation"
                (click)="isNavbarExpanded = !isNavbarExpanded">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse justify-content-center"
             id="navbarSupportedContent"
             [class.show]="isNavbarExpanded">
            <ul class="navbar-nav mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" href="https://medicalcostexperts.com/#process">
                        Our Process
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active"
                       href="https://medicalcostexperts.com/#methodology">
                        Methodology
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active"
                       href="https://medicalcostexperts.com/service-offerings/">
                        Service Offerings
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" href="https://medicalcostexperts.com/#pricing">
                        Pricing
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link active"
                       href="https://medicalcostexperts.com/contact/">
                        Contact
                    </a>
                </li>
            </ul>
        </div>
    </div>
</nav>

<div class="d-flex flex-column h-100">
    <main class="flex-fill">
        <router-outlet></router-outlet>
    </main>

    <footer>
        <div class="bg-secondary py-4">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 mb-5">
                        <img src="images/logo-white.png" alt="Abacus Analytics Logo" class="img-fluid" />
                    </div>

                    <div class="col-md-4 mb-4 text-md-end text-center">
                        <div class="h3 text-white mb-4">
                            Links
                        </div>

                        <ul class="list-unstyled">
                            <li>
                                <a href="https://medicalcostexperts.com/service-offerings/">
                                    Service Offerings
                                </a>
                            </li>
                            <li>
                                <a href="https://medicalcostexperts.com/contact/">
                                    Contact Us
                                </a>
                            </li>
                            <li>
                                <a href="https://medicalcostexperts.com/privacy-policy">
                                    Privacy Policy
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="col-md-4 mb-4 text-md-end text-center">
                        <div class="h3 text-white mb-4">
                            Contact
                        </div>

                        <div>
                            Phone: 844-633-2678
                        </div>
                    </div>
                </div>

                <hr />

                <div class="text-center">
                    © 2024 – Abacus Analytics All Rights Reserved
                </div>
            </div>
        </div>
    </footer>

    <div aria-live="polite" aria-atomic="true" class="bg-body-secondary position-relative bd-example-toasts rounded-3">
        <div class="toast-container position-fixed p-3 end-0 bottom-0" id="toastPlacement">
            <div class="toast fade" [class.show]="isToasVisible">
                <div class="toast-body text-bg-success">
                    Request submitted successfully!
                </div>
            </div>
        </div>
    </div>
</div>